module.exports = __webpack_public_path__ + "img/DefaultG.99cd258b.png";